export default class MarcheEffectifInfosDto {
  id;
  marche;
  nbEffectifEnCumule;
  nbMaxEffectifCadre;
  nbMaxEffectifOuvrier;
  nbEffectifADate;
  nbEmploiGroupCadre;
  nbEmploiGroupCadreMasc;
  nbEmploiGroupCadreFem;
  nbEmploiGroupEtam;
  nbEmploiGroupEtamMasc;
  nbEmploiGroupEtamFem;
  nbEmploiGroupOuvrier;
  nbEmploiGroupOuvrierMasc;
  nbEmploiGroupOuvrierFem;
  nbEmploiSousTraitantCadre;
  nbEmploiSousTraitantCadreMasc;
  nbEmploiSousTraitantCadreFem;
  nbEmploiSousTraitantEtam;
  nbEmploiSousTraitantEtamMasc;
  nbEmploiSousTraitantEtamFem;
  nbEmploiSousTraitantOuvrier;
  nbEmploiSousTraitantOuvrierMasc;
  nbEmploiSousTraitantOuvrierFem;
  nbTravDetach;
  nbHeureChantier;
  nbHeureFormation;
  nbHeureMois;
  nbHeureTotalInsertionRealisee;
  pieceJustificative;
  commentaire;
  statut;
  jourSoumissionPassed;
  date;
  nbDontEffectifChantier;
  user;
}
